
import { Component, Inject, Vue } from 'vue-property-decorator';
import { getMarkerColor, getMarkerWithObjects,getFilteredMarkers } from './util';
import State from './state';
import { MarkerWithObjects } from './types';
import { formatDateTime } from '../../../util';

@Component
export default class MarkerList extends Vue {
  @Inject()
  readonly state!: State;
  //private filterText: string = '';
  //private onlyIssues: boolean = false;
  markerRowEls: Record<string, HTMLElement | undefined> = {};

  getMarkerColor = getMarkerColor; //required to be used in template, vue2 shortcoming
  formatDateTime = formatDateTime;

	get rows(): MarkerWithObjects[] {
		// Pulls centrally filtered records and preserves sorting order
	  return getFilteredMarkers(this.state)
		  .sort((a, b) => b.activities.length - a.activities.length);
	}

  mounted(): void {
    this.state.activityStore.loadIfAbsent();
    this.state.cellStore.loadIfAbsent();
  }

  setMarkerRowRef(id: string) {
    return (el: HTMLElement | null) => {
      if (el) this.markerRowEls[id] = el;
    };
  }

  selectMarker(id: string): void {
    this.state.selectedMarkerId = id;
    this.$nextTick(() => {
      const el = this.markerRowEls[id];
      el?.scrollIntoView?.({ block: 'nearest' });
    });
  }

  removeMarker(id: string): void {
    const index = this.state.markers.findIndex(m => m.id === id);
    if (index >= 0) {
      this.state.markers.splice(index, 1);
    }
    if (this.state.selectedMarkerId === id) {
      this.state.selectedMarkerId = null;
    }
  }
}
